// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__LgWqz","checkbox":"SuperCheckbox_checkbox__r74P8","spanClassName":"SuperCheckbox_spanClassName__2THiH"};